<template>
  <div class="content">
    <div class="content_top">
      <h3 class="content_title">
        {{ title }}：
      </h3>
      <a-button @click="toEdit">
        {{ $t('message["36"]') }}
      </a-button>
      <div
        v-if="type === 'sentive'"
        class="sentive-switch"
      >
        <span class="fs-red">{{ $t('message[1979]') }}</span>
        <a-popover
          overlay-class-name="universal-tips-pop"
        >
          <template slot="content">
            <p>{{ $t('message[1980]') }}</p>
          </template>
          <i class="iconfont  iconicon-test31 m-l-8 m-r-8 fs-gray" />
        </a-popover>
        <a-switch
          :checked="!!sensitiveFields.is_hidden_sensitive_field"
          @change="openHandle"
        />
        <span class="open-txt m-l-8">{{ !!sensitiveFields.is_hidden_sensitive_field ? $t('message[1466]') : $t('message[1459]') }}</span>
      </div>
    </div>
    <div
      v-if="dataIsReady"
      class="content_main"
    >
      <div
        v-if="fields.length > 0"
        class="main_item"
      >
        <a-tag
          v-for="item in fields"
          :key="item.id || item.fieldkey"
        >
          {{ item.fieldname }}
        </a-tag>
      </div>
      <div
        v-else
        class="main_item"
      >
        <span v-text="untext" />
      </div>
    </div>
    <!-- <a-spin v-else /> -->
  </div>
</template>

<script type="text/ecmascript-6">
import i18n from '@/lib/language'
import { mapState } from 'vuex'
export default {
  props: {
    title: {
      type: String,
      default: i18n.t('message["646"]')
    },
    fields: {
      type: Array,
      default: () => []
    },
    untext: {
      type: String,
      default: i18n.t('message["1556"]')
    },
    type: {
      type: String,
      default: ''
    },
    sensitiveFields: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState('config/sensitive', ['dataIsReady', ''])
  },
  methods: {
    toEdit () {
      this.$emit('edit')
    },
    openHandle (val) {
      this.$emit('setSentiveHide', val)
    }

  }
}
</script>

<style scoped lang="scss">
.content {
  margin: 24px 0;
  .content_title {
    display: inline-block;
    width: 130px;
    font-size: 14px;
    margin-right: 24px;
    color: rgba(102, 102, 102, 1);
    text-align: right
  }
  .content_main {
    margin: 20px 0;
    .main_item {
      width: 700px;
      margin-left: 155px;
      color: rgba(179, 179, 179, 1);
      .ant-tag {
        margin-bottom: 12px
      }
    }
  }
  .sentive-switch{
    display: inline-block;
    line-height: 22px;
    vertical-align: middle;
  }
}
</style>
